<template>
  <div class="content-panel-login">
    <header class="login-header">
      <img class="logo-img" :src="logo" />
    </header>
    <div class="login-body">
      <stroked-container>
        <button>
          <a v-link="{ path: '/login' }" v-html="buttonClose"></a>
        </button>
        <div class="unsupported">
          <h1>Oops, outdated or unsupported browser detected.</h1>
          <p>
            You are seeing this message because we detected an outdated or
            unsupported browser being used. We recommend that you udpate to the
            latest version of Chrome, Firefox, Internet Explorer, or Safari to
            ensure you can access Keyboarding Without Tears.
          </p>
          <h2 class="links">
            Use the links below to download the latest version of supported
            browsers.
          </h2>
          <ul>
            <li>
              <a href="https://www.google.com/chrome/" class="icon chrome">
                Chrome
              </a>
            </li>
            <li>
              <a href="https://www.firefox.com/" class="icon firefox">
                Firefox
              </a>
            </li>
            <li v-if="!isMac" class="icon edge">
              <a href="http://www.microsoft.com/en-us/windows/microsoft-edge/">
                Edge
              </a>
            </li>
            <li v-if="isMac">
              <a href="http://www.apple.com/safari/" class="icon safari">
                Safari
              </a>
            </li>
          </ul>
          <p>
            Already upgraded but still having problems? Contact Customer Care at
            888-983-8409 or
            <a href="mailto:technology@hwtears.com">Email Us</a>.
          </p>
        </div>
      </stroked-container>
    </div>
  </div>
</template>

<script>
import kwtLogo from 'images/KWTLogo-2017.png';
import btnClose from 'assets/svg/login-button-close.svg';
import StrokedContainer from './StrokedContainer.vue';

export default {
  components: {
    StrokedContainer
  },
  data() {
    return {
      logo: kwtLogo,
      buttonClose: btnClose
    };
  },
  ready() {},
  computed: {
    isMac() {
      return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin backgroundImage($url) {
  background-image: url($url);
  background-repeat: no-repeat;
  background-origin: padding-box;
  background-size: 100% 100%;
}

.content-panel-login {
  * {
    box-sizing: border-box;
  }
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.login-body {
  flex: 1;
  background-color: #2e70be;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 40px;
  height: 100%;
}

.stroked-container {
  padding: 20px 40px;
  width: 70%;
  position: relative;
}

h1,
h2 {
  font-family: hwtfutura-semibold;
}

h1 {
  font-size: 21px;
  margin-bottom: 10px;
}

h2,
p {
  font-size: 16px;
  color: black;
}

ul {
  list-style: none;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  padding: 0;
}

header {
  background-color: #fecb45;
  width: 100%;
  text-align: center;
  padding: 10px 0;

  img {
    width: 60%;
  }
}

button {
  position: absolute;
  right: -30px;
  top: -30px;
  height: 80px;
  width: 80px;
  background-color: transparent;
  border: none;
}

.icon {
  display: block;
  width: 64px;
  height: 64px;
  font-family: hwtfutura-semibold;
  color: black;
  text-decoration: none;
  padding: 0 0 0 64px;
  line-height: 64px;

  &.hover {
    text-decoration: underline;
  }

  &.chrome {
    @include backgroundImage(
      "./../../assets/images/unsupported/chrome_128x128.png"
    );
  }

  &.firefox {
    @include backgroundImage(
      "./../../assets/images/unsupported/firefox_128x128.png"
    );
  }

  &.edge {
    @include backgroundImage(
      "./../../assets/images/unsupported/edge_128x128.png"
    );
  }

  &.safari {
    @include backgroundImage(
      "./../../assets/images/unsupported/safari_128x128.png"
    );
  }
}
</style>
